import {request} from "../request/request";

const classroom = {
  filters: () => request.read('/classroom/filters'),
  all: (params) => request.read('/classroom', params),
  reserve: (data) => request.create('/classroom/reserve', data),
};

export {classroom};